import { writeFileSync } from 'fs';
import envfile from 'envfile';
import { PATH } from '../../config';

export default ({ address, token, user, webPort }) => {
  writeFileSync(
    PATH,
    envfile.stringifySync({
      ADDRESS: address,
      TOKEN: token,
      USER: user,
      WEB_PORT: webPort,
    }),
  );
};
